export const fileBoxActionTypes = {
    STORE_FILEBOX_TEAMS: "STORE_FILEBOX_TEAMS",
    STORE_FILEBOX_CASES: "STORE_FILEBOX_CASES",
    STORE_FILEBOX_CASE: "STORE_FILEBOX_CASE"
}